import {Component, OnInit} from '@angular/core';
import {BreadcrumbService, BreadcrumbSnapshot} from './breadcrumb.service';
import {isNullOrUndefined} from 'util';
import {BreadcrumbLabel} from './breadcrumb';
import {dropRight} from 'lodash';
import {Keys, StorageService} from '../../../service/storage.service';

class NavigatorBreadcrumb {
    private label: BreadcrumbLabel | string;
    private url: string;

    constructor(label: BreadcrumbLabel | string, url: string) {
        this.label = label;
        this.url = url;
    }
}

// TODO Make it generic

@Component({
    selector: 'app-borrower-dashboard-breadcrumbs',
    templateUrl: './borrower-dashboard-breadcrumbs.component.html',
    styleUrls: ['./borrower-dashboard-breadcrumbs.component.scss']
})
export class BorrowerDashboardBreadcrumbsComponent implements OnInit {
    private pathDepth: number;
    breadcrumbs: NavigatorBreadcrumb[];

    constructor(private storageService: StorageService) {
    }

    ngOnInit(): void {
        [this.breadcrumbs, this.pathDepth] = this.restoreFromCache();

        BreadcrumbService.breadcrumbChange.subscribe((snapshot: BreadcrumbSnapshot) => {
            if (snapshot === null) {
                this.breadcrumbs.length = 0;
                this.pathDepth = 0;
            } else {
                const newPathDepth = snapshot.urlTree.root.children.primary.segments.length;
                this.updateBreadcrumbs(snapshot, newPathDepth);
                this.cache(this.breadcrumbs, newPathDepth);
                this.pathDepth = newPathDepth;
            }
        });
    }

    private updateBreadcrumbs(snapshot: BreadcrumbSnapshot, newPathDepth: number): void {
        if (isNullOrUndefined(this.pathDepth) || newPathDepth > this.pathDepth) {
            this.breadcrumbs.push(new NavigatorBreadcrumb(snapshot.label, snapshot.urlTree.toString()));
        } else {
            const pathHops = this.pathDepth - newPathDepth;
            this.breadcrumbs = dropRight(this.breadcrumbs, pathHops);
        }
    }

    private cache(breadcrumbs, pathDepth) {
        this.storageService.saveObjectToSession(Keys.BorrowerDashboardBreadcrumbs, breadcrumbs);
        this.storageService.saveObjectToSession(Keys.BorrowerDashboardBreadcrumbsPathDepth, pathDepth);
    }

    private restoreFromCache(): [NavigatorBreadcrumb[], number] {
        if (!this.breadcrumbs) {
            const cachedBreadcrumbs = this.storageService.getObjectFromSession<NavigatorBreadcrumb[]>(Keys.BorrowerDashboardBreadcrumbs);
            const cachedPathDepth = this.storageService.getObjectFromSession<number>(Keys.BorrowerDashboardBreadcrumbsPathDepth);
            return [cachedBreadcrumbs ? cachedBreadcrumbs : [], cachedPathDepth];
        }
    }
}
